export const quizPracticeLink = "https://www.giac.org/frequently-asked-questions/#practice";
export const myCoursesUrl = "https://ondemand.sans.org/";
export const accountDashboardUrl = "https://www.sans.org/account";
export const logoutUrl = "https://www.sans.org/account/logout";
export const sansHomeUrl = "https://www.sans.org/";
export const impersonationLoadingMessageKey = "impersonationLoadingMessage";
export const impersonationAdminReturnUrlKey = "impersonationAdminReturnUrl";
export const impersonationAdminReturnUrlParam = "adminReturnUrl";
export const impersonationReturnToAdminKey = "impersonationReturnToAdmin";
export const privacyPolicyUrl = "https://www.sans.org/privacy/";
import { env } from "./env";

export const telemetryApiUrl: string = env.VITE_TELEMETRY_ENDPOINT as string;
export const telemetryChannelName = "telemetry";
export const playerModality = "web2";
export const speedModifier = 0.1;
export const timeoutSeconds = 90;
export const saveProgressInterval = 60;
export const dropboxOauthUrl = "https://www.dropbox.com/oauth2/authorize";
export const testNetworkSpeedSettings = {
  testFilePath: "/assets/1mb-test-data.txt",
  networkSpeedCheckMinMinutes: 5,
};

// Video Quality Selection Logic
export const VIDEO_QUALITY_THRESHOLDS = {
  VBR: 0.0, // Variable bitrate - no threshold
  FHD: 5.0, // 1080p - requires 5+ Mbps
  HD: 3.0, // 720p - requires 3+ Mbps
  SD: 0.0, // 480p - fallback for slower connections
};

// Error Messages
export const GEO_BLOCKING_ERROR_MESSAGE = "not available in your region";
